<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
  <a-modal
    :title="props.detailData.title + '-阅读详情'"
    :width="1000"
    :open="true"
    :confirmLoading="state.loading"
    :maskClosable="false"
    @ok="onFormSubmit"
    @cancel="
      () => {
        emit('cancel')
      }
    "
    ><a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item label="创建时间" name="between_time">
                <a-range-picker :show-time="{ defaultValue: arrayMonent }" :value="rangTime" @change="rangTimeChange" :format="format"></a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <span class="table-page-search-submitButtons">
                <a-button type="primary" @click="loadData">查询</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table :columns="columns" :loading="state.loading" :data-source="dataSource" :pagination="pagination" @change="onChange" rowKey="id">
        <template #bodyCell="{ column, record, index, text }">
          <template v-if="column.dataIndex === 'type_name'">
            <a-tag v-if="record.type == 1" color="green">{{ text }}</a-tag>
            <a-tag v-else>{{ text }}</a-tag>
          </template>
          <template v-if="column.dataIndex === 'money'">
            <span v-if="record.money < 0" style="color: red">{{ text }} </span>
            <span v-else>{{ text }}</span>
          </template>
        </template>
      </a-table>
    </a-card>
  </a-modal>
</template>
<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import type { PaginationProps } from 'ant-design-vue'
import dayjs from 'dayjs'
const arrayMonent = [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')]
const format = 'YYYY-MM-DD HH:mm:ss'
const props = defineProps({
  detailData: {
    type: Object,
    default: () => null
  }
})
const emit = defineEmits(['cancel'])
const columns = [
  {
    title: '姓名',
    dataIndex: 'nickname',
    width: 200
  },
  {
    title: '阅读时间',
    dataIndex: 'created_at',
    width: 200
  },
  {
    title: '最后一次阅读时间',
    dataIndex: 'updated_at',
    width: 200
  }
]
interface state {
  loading: boolean
  detailData: object
  detailVisible: boolean
}
const state = reactive<state>({
  loading: false,
  detailData: {},
  detailVisible: false
})
let queryParam = reactive<any>({
  remark: ''
})
let dataSource = ref([])
const pagination = reactive<PaginationProps>({
  pageSize: 10,
  pageSizeOptions: ['10', '50', '100', '200', '1000', '2000'],
  current: 1,
  total: undefined,
  showSizeChanger: true,
  showQuickJumper: true,
  showTotal: (total) => `总数：${total}`
})
onMounted(() => {
  loadData()
})
// 时间选择
const rangTime = computed(() => {
  let array: any = []
  if (queryParam.between_time) {
    array = queryParam.between_time.split(',').map((item) => dayjs(item ? item : null, format))
  } else {
    array = []
  }
  return array
})
// 时间选择
const rangTimeChange = (val, str) => {
  if (val) {
    queryParam.between_time = str.join(',')
  } else {
    queryParam.between_time = null
  }
}
const loadData = () => {
  state.loading = true
  // 获取到列表数据
  let requestParam = {
    url: '/admin/v1/news/newsRead',
    method: 'post',
    data: Object.assign({ page: pagination.current, limit: pagination.pageSize, news_id: props.detailData.id }, queryParam)
  }
  baseService(requestParam).then((res) => {
    state.loading = false
    pagination.total = res.data.total_records
    dataSource.value = res.data.list.map((item) => ({ ...item, isDetail: false }))
  })
}
const onChange = (val) => {
  pagination.pageSize = val.pageSize
  pagination.current = val.current
  loadData()
}
const onFormSubmit = () => {
  emit('cancel')
}
</script>
<style lang="less" scoped></style>
